<template>
    <div id="modal-holder">
<!--        <ModalAdminPageAddProduct/>-->
<!--        <ModalAdminPageAddCollection/>-->
<!--        <ModalAdminPageAddProject/>-->
<!--        <ModalAdminPageAddCustomer/>-->
<!--        <ModalAdminPageAddUser/>-->
<!--        <ModalAdminPageAddOrganization/>-->
        <modals-container/>
    </div>
</template>

<script>
    // import ModalAdminPageAddProduct from "./AdminPage/ModalAdminPageAddProduct";
    // import ModalAdminPageAddCollection from "./AdminPage/ModalAdminPageAddCollection";
    // import ModalAdminPageAddProject from "./AdminPage/ModalAdminPageAddProject";
    // import ModalAdminPageAddCustomer from "./AdminPage/ModalAdminPageAddCustomer";
    // import ModalAdminPageAddUser from "./AdminPage/PageUsers/AddUser";
    // import ModalAdminPageAddOrganization from "./AdminPage/ModalAdminPageAddOrganization";

    export default {
        name: "TheAdminPageModal",
        components: {
            // ModalAdminPageAddOrganization,
            // ModalAdminPageAddUser,
            // ModalAdminPageAddCustomer,
            // ModalAdminPageAddProject,
            // ModalAdminPageAddCollection,
            // ModalAdminPageAddProduct
        }
    }
</script>

<style>
    .field-name{
        font-size: 18px;
        color: #303030;
        margin: 5px 30px;
    }
    .modal-img-container {
        width: 100%;
        height: auto;
    }

    .modal-img {
        width: 100%;
        max-height: 250px;
        object-fit: cover;
    }

    .modal-close-btn-point {
        position: absolute;
        /*bottom: 265px;*/
        top: 9px;
        /*left: 530px;*/
        right: 59px;
        width: 0;
        height: 0;
    }

    .modal-close-btn {
        cursor: pointer;
    }
    .modal-close-btn:hover .modal-close-circle {
        fill: #b82325;
    }

    .modal-close-btn:active .modal-close-circle {
        fill: #ad0e27;
    }

    .modal-title {
        margin: 30px;
        font-weight: bold;
        font-size: 20px;
        color: #303030;
    }

    .modal-title-thin {
        margin: 15px 30px;
        font-weight: bold;
        font-size: 20px;
        color: #303030;
    }

    .modal-close-btn-container{
        display: flex;
        width: max-content;
        height: max-content;
        justify-content: center;
        align-items: center;
    }

    .modal-text {
        margin: 30px;
        font-size: 16px;
    }

    .modal-list {
        margin: 20px 10px;
        padding: 0;
        /*font-size: 16px;*/
    }

    .modal-text-input {
        width: calc(100% - 82px);
        padding: 10px;
        margin: 10px 30px;
        border: 1px solid #BDBDBD;
    }

    .modal-photo-carousel {
        display: flex;
        justify-content: safe center;
        margin: 0 30px;
        /*width: 100%;*/
        height: 220px;
        /*overflow-x: auto;*/
        /*overflow-y: hidden;*/
    }

    .modal-photo-carousel-element {
        display: inline;
        width: auto;
        height: 200px;
        margin-right: 10px;
    }

    .ap-modal-button {
        background-color: #e4373a;
        padding: 10px 20px;
        margin: 30px;
        color: white;
        font-weight: bold;
        width: max-content;
        cursor: pointer;
        user-select: none;
    }

    .ap-modal-button:hover {
        background-color: #b82325;
    }

    .ap-modal-button:active {
        background-color: #e4373a;
    }
</style>
